import { Avatar, Box, Button, Divider, Typography } from '@mui/material'
import { BestIcon, FeatIcon } from '../../../../../../../core/global/Icons';
import { CallOutlined, Facebook } from "@mui/icons-material"
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import { avatarPropStyles } from '../../../../../../../core/styling/global';


export const Container = ({ viewdata }) => {
	const inputs = viewdata.data
	return (
		<Box width={343} display={"flex"} alignItems="center" flexDirection="column" pb={6}>
			<Box py={2}>
				<Typography width="100%" fontSize={40} fontWeight={600} color="#313131">{inputs.content.title}</Typography>
				<Typography width="100%" fontSize={12} fontWeight={400} mt={1} color="#6A6A6A">{inputs.content.title_description}</Typography>
			</Box>
			<Box width="100%" pt={1} pb={2} display="flex" alignItems="center" gap={2}>
				<Box fontSize={24} fontWeight={400} color="#313131">{inputs.content.start_price}</Box>
				<Box fontSize={24} fontWeight={700} color="#ED9140" >₱ {inputs.content.price}</Box>
			</Box>

			<Box width="100%" display="flex" justifyContent="space-between" alignItems="center">
				<Box width={303} height={268} >
					<Box sx={avatarPropStyles(inputs.content.images.first_img, '100%', "100%", 4)}></Box>
				</Box>
				<Box width={32}>
					<Box width="100%" display={"flex"} alignItems="center" flexDirection="column" gap={1}>
						<img style={{ width: "100%", height: "32px" }} alt={inputs.content.images.first_img} src={inputs.content.images.first_img} />
						<img style={{ width: "100%", height: "32px" }} alt={inputs.content.images.second_img} src={inputs.content.images.second_img} />
						<img style={{ width: "100%", height: "32px" }} alt={inputs.content.images.third_img} src={inputs.content.images.third_img} />
						<img style={{ width: "100%", height: "32px" }} alt={inputs.content.images.fourth_img} src={inputs.content.images.fourth_img} />
						<img style={{ width: "100%", height: "32px" }} alt={inputs.content.images.fifth_img} src={inputs.content.images.fifth_img} />
						<img style={{ width: "100%", height: "32px" }} alt={inputs.content.images.sixth_img} src={inputs.content.images.sixth_img} />
					</Box>
				</Box>
			</Box>
			<Button fullWidth sx={{ mt: 4, fontSize: 14, fontWeight: 500, bgcolor: "#ED9140", color: "#FFFFFF", height: 44, borderRadius: "6px", ':hover': { bgcolor: "#ED9140", color: "#FFFFFF" } }}>{inputs.content.buttons.second.label}</Button>
			{/* <Button fullWidth sx={{ mt: 1, fontSize: 14, fontWeight: 500, bgcolor: "#FFFFFF", color: "#313131", height: 44, border: "solid 1px", borderRadius: "6px", ':hover': { bgcolor: "#FFFFFF", color: "#313131" } }}>{inputs.content.buttons.first.label}</Button> */}

			<Box width="100%" display="flex" alignItems="center" py={4} gap={2}>
				<Divider sx={{ width: "38%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
				<Typography display="flex" alignItems="center" fontSize={12} color="#e3e3e3"gap={2}><Box>#</Box><Box>#</Box><Box>#</Box></Typography>
				<Divider sx={{ width: "38%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
			</Box>

			<Box width="100%" height={125} borderRadius={3} bgcolor="#FBF8F7" p={2}>
				<Box display="flex" alignItems="center" gap={1} >
					<BestIcon />
					<Box fontSize={16} fontWeight={600}>{inputs.content.bestfor_title.value}</Box>
				</Box>
				<Box p={1} width="100%" display="flex" alignItems="center" flexDirection="column">
					<Box width="100%" display="flex" alignItems="center" flexWrap="wrap" fontSize={16} fontWeight={400}>
						{inputs.content.bestfor_items.map((i, k) => (
							<Box width="50%" fontSize={12} fontWeight={400} key={k} 
							>•  {i}</Box>
						))}
					</Box>
				</Box>
			</Box>

			<Box mt={1} width="100%" height={125} borderRadius={3} bgcolor="#FBF8F7" p={2}>
				<Box display="flex" alignItems="center" gap={1} >
					<FeatIcon />
					<Box fontSize={16} fontWeight={600} >{inputs.content.feature_title}</Box>
				</Box>
				<Box p={1} width="100%" display="flex" alignItems="center" flexDirection="column">
					<Box width="100%" display="flex" alignItems="center" flexWrap="wrap" fontSize={16} fontWeight={400} >
						{inputs.content.feature_items.map((i, k) => (
							<Box width="50%" fontSize={12} fontWeight={400} key={k} >• {i}</Box>
						))}
					</Box>
				</Box>
			</Box>

			<Box width="100%" display="flex" alignItems="center" py={3} gap={2}>
				<Divider sx={{ width: "38%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
				<Typography display="flex" alignItems="center" fontSize={12} color="#e3e3e3"gap={2}><Box>#</Box><Box>#</Box><Box>#</Box></Typography>
				<Divider sx={{ width: "38%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
			</Box>

			<Box>
				<Typography fontSize={16} fontWeight={600}>{inputs.content.atp_title}</Typography>
				<Typography fontSize={12} fontWeight={400} py={.5} >{inputs.content.atp_description}</Typography>
			</Box>

			<Box width="100%" display="flex" alignItems="center" py={3} gap={2}>
				<Divider sx={{ width: "38%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
				<Typography display="flex" alignItems="center" fontSize={12} color="#e3e3e3"gap={2}><Box>#</Box><Box>#</Box><Box>#</Box></Typography>
				<Divider sx={{ width: "38%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
			</Box>

			<Box>
				<Box display="flex">
					<Avatar sx={{ width: 56, height: 56 }} alt={inputs.content.images.owner_img} src={inputs.content.images.owner_img} />
					<Box>
						<Box px={1} width="100%" fontSize={20} fontWeight={600} >{inputs.content.owner_name}</Box>
						<Box px={1} width="100%" fontSize={16} fontWeight={400} >{inputs.content.owner_title}</Box>
					</Box>
				</Box>
				<Typography width="100%" fontSize={12} fontWeight={400}  my={2} >{inputs.content.owner_description}</Typography>
			</Box>

			<Box width="100%" display="flex" alignItems="center" py={3} gap={2}>
				<Divider sx={{ width: "38%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
				<Typography display="flex" alignItems="center" fontSize={12} color="#e3e3e3"gap={2}><Box>#</Box><Box>#</Box><Box>#</Box></Typography>
				<Divider sx={{ width: "38%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
			</Box>
			<Box width="100%">
				<Box fontSize={16} fontWeight={600} >{inputs.content.contact_title}</Box>
				<Box display="flex" gap={2} pt={1}>
					<Box fontSize={16} fontWeight={400}  display="flex" alignItems="center" > <PhoneIphoneIcon sx={{ color: '#999797', fontSize: 24 }} />{inputs.content.cellphone_num}</Box>
					<Box fontSize={16} fontWeight={400} display="flex" alignItems="center" > <CallOutlined sx={{ color: '#999797', fontSize: 24, mr: 2 }} />{inputs.content.telephone_num}</Box>
				</Box>
			</Box>

			<Box width="100%" pt={2}>
				<Box width="100%" fontSize={16} fontWeight={600}>{inputs.content.social_title.value}</Box>
				<Box display="flex" alignItems="center" pt={1}>
					<Facebook sx={{ width: 25.6, color: 'orange', fontSize: 30, borderRadius: 64, cursor: "pointer" }} />
					<InstagramIcon sx={{ width: 25.6, color: 'orange', fontSize: 30, borderRadius: 64, mx: 3, cursor: "pointer" }} />
					<TwitterIcon sx={{ width: 25.6, color: 'orange', fontSize: 30, borderRadius: 64, cursor: "pointer" }} />
				</Box>
			</Box>
		</Box>
	)
}
